import { useCallback, useEffect, useState } from "react";
import { PiggyBank, Landmark, Users, HandCoins, TrendingDown, ClipboardList, Flame, Gauge, PoundSterling, CalendarClock } from "lucide-react";
import { StatCard } from "@/components/common/StatCard";
import { api } from "@/lib/api";
import { gbp2 } from "@/data/financeOptions";

export const FinanceSummary = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  const load = useCallback(async () => { try { setS(await api.list("finance-summary")); } catch { setS(null); } }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const runwayTone = s?.runway_limited ? (s.runway_months <= 6 ? "coral" : s.runway_months <= 12 ? "orange" : "teal") : "teal";
  const cards = [
    { label: "Available Cash", value: s ? gbp2(s.available_cash) : "—", icon: PiggyBank, tone: "jungle" },
    { label: "Funding Received", value: s ? gbp2(s.total_funding_received) : "—", icon: Landmark, tone: "gold" },
    { label: "Founder Contributions", value: s ? gbp2(s.total_founder_contributions) : "—", icon: Users, tone: "teal" },
    { label: "Outstanding Loans", value: s ? gbp2(s.outstanding_loans) : "—", icon: HandCoins, tone: "royal" },
    { label: "Spend This Month", value: s ? gbp2(s.actual_spend_month) : "—", icon: TrendingDown, tone: "orange" },
    { label: "Committed Spend", value: s ? gbp2(s.committed_spend) : "—", icon: ClipboardList, tone: "royal" },
    { label: "Avg Monthly Burn", value: s ? gbp2(s.avg_monthly_burn) : "—", icon: Flame, tone: "orange" },
    { label: "Estimated Runway", value: s ? (s.runway_limited ? `${s.runway_months}` : "∞") : "—", hint: s ? (s.runway_limited ? "months" : "Not limited by burn") : undefined, icon: Gauge, tone: runwayTone },
    { label: "Revenue This Month", value: s ? gbp2(s.revenue_month) : "—", icon: PoundSterling, tone: "jungle" },
    { label: "Upcoming (30 days)", value: s ? gbp2(s.upcoming_total) : "—", hint: s ? `${s.upcoming_count} payment${s.upcoming_count === 1 ? "" : "s"}` : undefined, icon: CalendarClock, tone: "royal" },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" data-testid="finance-summary">
      {cards.map((c, i) => <StatCard key={c.label} index={i} testid={`finance-stat-${i}`} {...c} />)}
    </div>
  );
};
